import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ActionsService } from '../services/actions.service';
import { ProfileService } from '../../profile/services/profile.service';
import { PermissionsService } from '../../permissions/services/permissions.service';
import { CRUD } from '../../core/constants/crud.constants';
import { PermissionsModel } from '../models/permissions.model';
import { profile } from 'console';

export const actionsGuard: CanActivateFn = (route, state) => {
  const service = inject(ActionsService);
  const profileService = inject(ProfileService);
  const permissionsService = inject(PermissionsService);
  const profile = profileService.profile();
  if (profile?.user_type?.access) {
    return true;
  }
  const resource = profileService.extraerValor(state.url)
  if (!resource) {
    return true;
  }
  return permissionsService.hasPermission(
    profile?.role?.permissions,
    resource.resource,
    service.normalizarAccion(resource.action)
  );
};
